import React from "react";
import "./ReallocationLog.css";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Widgets from "../../../../widgets";
import Icons from "../../../../Assets/Icons";
import strings from "../../../../utils/strings";

const ReallocationLog = () => {
  const { t } = useTranslation();
  const nav = useNavigate();

  const breadcrumbs = ["nursingCare", "manageRequests", "reallocationLog"];
  const paths = [strings.navigation.manageNurseReq, `${strings.navigation.manageNurseReq}?activeList=approved`, strings.navigation.reallocationLog];

  const logEntries = [
    {
      id: "LOG-001",
      patientName: "Nguyen Van A",
      patientEmail: "nguyen.a@email.com",
      profilePic: Icons.profileimg,
      originalNurse: "Tran Thi B",
      reassignedNurse: "Pham Thi D",
      reassignedBy: "Admin",
      timestamp: "20 Jan 2025, 14:30",
    },
    {
      id: "LOG-002",
      patientName: "Le Van C",
      patientEmail: "le.c@email.com",
      profilePic: Icons.profileimg,
      originalNurse: "Hoang Van E",
      reassignedNurse: "Le Thi F",
      reassignedBy: "Nurse",
      timestamp: "18 Jan 2025, 09:15",
    },
    {
      id: "LOG-003",
      patientName: "Tran Thi B",
      patientEmail: "tran.b@email.com",
      profilePic: Icons.profileimg,
      originalNurse: "Pham Thi D",
      reassignedNurse: "Tran Thi B",
      reassignedBy: "Admin",
      timestamp: "15 Jan 2025, 16:45",
    },
    {
      id: "LOG-004",
      patientName: "Pham Thi D",
      patientEmail: "pham.d@email.com",
      profilePic: Icons.profileimg,
      originalNurse: "Le Thi F",
      reassignedNurse: "Hoang Van E",
      reassignedBy: "Admin",
      timestamp: "10 Jan 2025, 11:20",
    },
    {
      id: "LOG-005",
      patientName: "Hoang Van E",
      patientEmail: "hoang.e@email.com",
      profilePic: Icons.profileimg,
      originalNurse: "Nguyen Van G",
      reassignedNurse: "Tran Thi B",
      reassignedBy: "Nurse",
      timestamp: "05 Jan 2025, 08:00",
    },
  ];

  const handleBack = () => {
    nav(`${strings.navigation.manageNurseReq}?activeList=approved`);
  };

  return (
    <div className="reallocation-log-container">
      <Widgets.BreadCrumb breadcrumbs={breadcrumbs} paths={paths} />
      <div className="department-heading">{t("reallocationLog")}</div>

      <div className="whp-container reallocation-table-card">
        <div className="reallocation-table-wrap">
          <table className="ppl-table">
            <thead className="ppl-thead">
              <tr>
                <th>{t("patientDetails")}</th>
                <th>{t("originalNurse")}</th>
                <th>{t("reassignedNurse")}</th>
                <th>{t("reassignedBy")}</th>
                <th>{t("timestamp")}</th>
              </tr>
            </thead>
            <tbody className="ppl-tbody">
              {logEntries.map((entry, index) => (
                <tr key={index} className="ppl-table-row reallocation-row">
                  <td>
                    <div className="ppl-td-first">
                      <div>
                        <img src={entry.profilePic} alt="profile" className="ppl-td-profile" />
                      </div>
                      <div className="ppl-name-email">
                        <section>{entry.patientName}</section>
                        <section className="ppl-email">{entry.patientEmail}</section>
                      </div>
                    </div>
                  </td>
                  <td>{entry.originalNurse}</td>
                  <td>{entry.reassignedNurse}</td>
                  <td>
                    <span className={`reallocation-by-badge ${entry.reassignedBy === "Admin" ? "by-admin" : "by-nurse"}`}>{entry.reassignedBy}</span>
                  </td>
                  <td>{entry.timestamp}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {logEntries.length === 0 && (
            <div className="no-record-container ppl">
              <div className="no-record-icon">
                <img src={Icons.NoData} alt="No Data Found" />
              </div>
              <div className="no-record-text">{t("noRecordFound")}</div>
            </div>
          )}
        </div>
      </div>

      <div className="form-section-footer reallocation-footer">
        <button className="form-section-cancel" onClick={handleBack}>
          {t("back")}
        </button>
      </div>
    </div>
  );
};

export default ReallocationLog;
